import {persistor} from "../index";

export const logout = () => {
    return persistor.purge();
}
